<template>
  <v-alert
    :icon="noResultsIcon ? 'mdi-circle-off-outline' : null"
    :class="[containerCssClass, type, { bordered: bordered }, { 'wx-alert-message--no-query-results': noResultsIcon }]"
    class="wx-alert-message"
  >
    <p :class="textCssClass" class="mb-0">{{ text }}</p>
  </v-alert>
</template>
<script>
export default {
  name: "WxAlertQueryMessage",
  props: {
    type: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      required: true,
    },
    noResultsIcon: {
      type: Boolean,
      default: false,
    },
    bordered: {
      type: Boolean,
      default: false,
    },
    containerCssClass: {
      type: String,
      default: null,
    },
    textCssClass: {
      type: String,
      default: "font-italic",
    },
  },
};
</script>

<style lang="scss" scoped>
.wx-alert-message {
  &.v-alert {
    // Default: Displays as a simple unstyled `div` container
    padding: 0;
    background-color: transparent !important;

    &.bordered {
      border: 1px solid var(--color-border-theme);
    }

    ::v-deep .v-alert__content {
      color: var(--color-text-subtle-theme);

      a:not(.v-icon):not(.v-btn) {
        color: var(--color-text-theme);
        text-decoration: underline;
      }
      p {
        word-break: keep-all;
      }
    }
  }

  &--no-query-results {
    &.v-alert {
      ::v-deep .v-alert {
        &__wrapper {
          .v-icon {
            color: var(--color-text-disabled-theme);
          }
        }
      }

      &.error {
        ::v-deep .v-alert {
          &__content {
            color: var(--color-error);
          }
          &__wrapper {
            .v-icon {
              color: var(--color-error);
            }
          }
        }
      }
      &.warning {
        ::v-deep .v-alert {
          &__wrapper {
            .v-icon {
              color: var(--color-warning);
            }
          }
        }
      }
      &.success {
        ::v-deep .v-alert {
          &__wrapper {
            .v-icon {
              color: var(--color-success);
            }
          }
        }
      }
      &.info {
        ::v-deep .v-alert {
          &__wrapper {
            .v-icon {
              color: var(--color-info);
            }
          }
        }
      }
    }
  }
}
</style>
